import { firebaseAuth, localisationUrl } from '../config';

// export function registerWithEmail(email, pw, onSuccess, onError) {
//   return firebaseAuth().createUserWithEmailAndPassword(email, pw).then(onSuccess).catch(onError);
// }

export function signInUser() {
  signinAnonymously()
    .then(({ uid }) => {
      fetch(`${localisationUrl}?uid=${uid}`, {
        mode: 'no-cors'
      });
      // analytics.countUser(uid);
    })
    .catch(console.warn);
}

export function resetPassword(email, onSuccess) {
  firebaseAuth().sendPasswordResetEmail(email).then(() => {
    onSuccess();
  }, console.warn);
}

export function login(email, pw, onSuccess, onError) {
  return firebaseAuth()
    .signInWithEmailAndPassword(email, pw)
    .then(onSuccess)
    .catch(onError);
}

export function signinAnonymously() {
  return firebaseAuth().signInAnonymously();
}
export function logout() {
  return firebaseAuth().signOut();
}



// WEBPACK FOOTER //
// ./src/utils/authUtils.js